<div class="wrapper wrapper-nofooter">
  <div class="container px-0">

    <h5 class="font-weight-bold mb-0 p-3 text-center">
      <i class="fas fa-check-circle check-icon fa-lg mb-3"></i>
      <br>
      <span>{{'checkin_thankyou.checkedin_complete' |translate}}</span>

      <!--<span *ngIf="alreadyCheckedin">{{'checkin_thankyou.checkedin_alredy_complete' |translate}}</span>-->
    </h5>
    <!--<h5 class="main-title">{{patientpersonalinfo?.PracticeName}}</h5>-->
    <!--<div class="row justify-content-center">
    <div class="col-md-6">



      <div class="card border">
        <div class="card-body p-0 text-center">
          <h5 *ngIf="isSpanishLang" class="bg-info font-weight-bold mb-0 p-3 text-white">
            {{'checkin_thankyou.checkedin' |translate}}
          </h5>
          <h5 *ngIf="isHindiLang" class="bg-info font-weight-bold mb-0 p-3 text-white">
            {{'checkin_thankyou.checkedin' |translate}}
          </h5>
          <h5 *ngIf="isEnglishLang" class="bg-info font-weight-bold mb-0 p-3 text-white">
            Checked-In
          </h5>

          <div *ngIf="storedIsWithin24Hours=='false' ||!IsWithin3Hours">
            <p *ngIf="isSpanishLang" class="mb-0 p-3">{{'checkin_thankyou.checkinMSgforInitial' |translate}} </p>
            <p *ngIf="isHindiLang" class="mb-0 p-3">{{'checkin_thankyou.checkinMSgforInitial' |translate}} </p>
            <p *ngIf="isEnglishLang" class="mb-0 p-3">You have successfully checked in to your doctor's clinic. We look forward to seeing you at your scheduled appointment. </p>
          </div>


          <div *ngIf="storedIsWithin24Hours=='true' || IsWithin3Hours">
            <p *ngIf="isSpanishLang" class="mb-0 p-3">  {{'checkin_thankyou.checkinMSg' |translate}}</p>
            <p *ngIf="isHindiLang" class="mb-0 p-3">  {{'checkin_thankyou.checkinMSg' |translate}}</p>
            <p *ngIf="isEnglishLang" class="mb-0 p-3" [innerHTML]="sanitizer.bypassSecurityTrustHtml(check_in_message)"></p>
          </div>

          <h5 *ngIf="isSpanishLang" class="bg-light font-weight-bold mb-0 p-3 text-info text-success">
          {{'checkin_thankyou.thankYou' |translate}}
        </h5>
        <h5 *ngIf="isHindiLang" class="bg-light font-weight-bold mb-0 p-3 text-info text-success">
          {{'checkin_thankyou.thankYou' |translate}}
        </h5>
        <h5 *ngIf="isEnglishLang" class="bg-light font-weight-bold mb-0 p-3 text-info text-success">
          Thank You!
        </h5>
        </div>
      </div>
    </div>
  </div>-->
    <!-- Appointment details -->



    <div class="row justify-content-center">
      <div class="col-md-6">

        <div class="card border">
          <div class="card-header bg-info font-weight-bold mb-0 p-3 text-white border-bottom">
            <h5 class="fw-bold text-center mb-0">{{'verifypatient.appointment_detail'|translate}}</h5>
          </div>
          <div class="card-header bg-info font-weight-bold mb-0 p-3 text-white">
            <!--<h5 class="fw-bold text-center mb-3">{{'verifypatient.appointment_detail'|translate}}</h5>-->
            <!--<div class="devider mb-4">
            <span>{{'insurances.insurance_or'|translate}}</span>
          </div>-->
            <h5 class="font-weight-bold text-center text-capitalize">{{patientFirstName}} {{patientLastName}} </h5>
            <p class="text-center mb-0">
              <ng-container *ngIf="currentLang === 'ur'; else otherLang">
                {{appointment_details?.appointment_Date_Time | date}}
                {{'appointmentDetails.at' | translate}}
                {{appointment_details?.time_From}}
              </ng-container>
              <ng-template #otherLang>
                {{appointment_details?.appointment_Date_Time | date}}
                {{'appointmentDetails.at' | translate}}
                {{appointment_details?.time_From}}
              </ng-template>
              <!--<br> {{'appointmentDetails.with' |translate}} <strong>Dr. {{appointment_details?.provid_FName}} {{appointment_details?.provid_LName}}</strong>-->
            </p>

          </div>
          <div class="card-body p-3 text-center">

            <strong class="text-center">{{appointment_details?.praC_NAME}}</strong>
            <br> <br>
            <!--<p class="text-center mb-0">
            <span>{{appointment_details?.praC_CITY}}</span>
          </p>-->
            <p class="text-center mb-0">
              <a href="https://www.google.com/maps/place/{{appointmentAddress}}, {{appointmentCity}}, {{appointmentState}} {{appointmentZip}}" target="_blank">
                {{appointmentAddress | titlecase}}, {{appointmentCity|titlecase}}, {{appointmentState}} {{appointmentZip}}
              </a>


            </p>
            <br>
            <strong class="text-center mb-0">
              <span>
                {{'checkin_thankyou.phone'|translate}}:
                <a href={{phoneLink}} class="ltr-component" style="direction: ltr; display: inline-block;">
                  {{appointment_details?.praC_PHONE}}
                </a>
              </span>
            </strong>



          </div>


          <!--<div class="card-footer p-3">
          <h5 class="font-weight-bold text-success mb-0 text-info text-center">{{'appointmentDetails.appointmentDetails_thankyou' |translate}}</h5>
        </div>-->
        </div>
      </div>
      <!--<strong class="text-center mt-5 mr-3 ml-3"> On the day of the appointment, notify us that you have arrived by clicking the button below. </strong>-->
    </div>
    <div *ngIf="isiOS || isAndroid" class="row justify-content-center mt-3">
      <div class="col-md-12">
        <div class="card">
          <div class=" p-0 ">
            <div class="mycontainer">
              <div *ngIf="isiOS">
                <a  href="https://apps.apple.com/us/app/talkphr-360-carecloud/id6746710207" target="_blank" rel="noopener" style="text-decoration:none; color:inherit;">
                  <div class="box">
                    <label style="color:#455a64">
                      Try your new <br><span style="font-size:30px">Talk<strong>PHR</strong> 360</span>
                      <br>
                      <img width="150" class="mt-1" src="assets/images/app-store.png" alt="App Store" />
                    </label>
                  </div>
                </a>
              </div>
              <div *ngIf="isAndroid">
                <a  href="https://play.google.com/store/apps/details?id=com.carecloud.primephr" target="_blank" rel="noopener" style="text-decoration:none; color:inherit;">
                  <div class="box">
                    <label style="color:#455a64">
                      Try your new <br><span style="font-size:30px">Talk<strong>PHR</strong> 360</span>
                      <br>
                      <img width="150" class="mt-1" src="assets/images/google-play.png" alt="play Store" />
                    </label>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
<footer class="p-3">
  <div class="container p-0">
    <div class="d-flex justify-content-center align-items-center">
      <button class="btn btn-primary" (click)="addToCalendar()">{{'button.add_to'|translate}}  <i class="fas fa-calendar-plus fa-lg"></i> </button>
      <!--<a class="btn btn-primary" type="button" >-->
      
        <!--<i class="fas fa-calendar fa-lg"></i>-->
        <!--<i class="fas fa-calendar-check fa-lg"></i>-->
        <!--<i class="fas fa-calendar-plus fa-lg"></i>-->
        <!--<i class="fas fa-calendar-day fa-lg"></i>-->
      <!--</a>-->
    </div>
  </div>
</footer>


<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="rateVisit-model">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body p-4 text-center">
        <!--<h5 class="font-weight-bolder mb-3 text-dark"><strong>{{appointment_details?.praC_NAME}} </strong></h5>-->
        <h5 class="font-weight-bolder mb-3"><strong>{{'checkin_thankyou.rateyourVisit' |translate}} </strong></h5>
        <!-- 5 Star Rating -->
        <div id="star-rating" class="star-rating">
          <span class="star" *ngFor="let star of stars; let i = index"
                [ngClass]="{ 'selected': i < rating }"
                (click)="rate(i + 1)">
            &#9733;
          </span>
        </div>
        <div *ngIf="rating>0" class="form-group mt-3">
          <textarea placeholder="{{'checkin_thankyou.feedbackComment' |translate}} " [(ngModel)]="feedbackComment" class="form-control p-2" id="comment" maxlength="120" rows="2"
                    tabindex="10" style="resize: none"
                    name="comment"></textarea>
        </div>
        <button type="button" data-toggle="modal" data-dismiss="modal" id="closeModal"
                class="btn btn-outline-primary mr-3" (click)="RateYourVisit()"  style="width:115px">
          {{'button.not_now'|translate}}
        </button>
        <button type="button" data-toggle="modal" data-dismiss="modal" id="close"
                class="btn btn-primary rbtn" (click)="RateYourVisit()" style="width:115px">
          {{'button.send'|translate}}
        </button>
      </div>
    </div>
  </div>
</div>
